import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import NewNotificationDrawer from './NotificationsTab/NewNotificationDrawer';
import { useToggle } from 'react-use';
import { StylishNewToggleButtonGroup } from 'components/DesignSystems/New/StylishNewToggleButtonGroup';
import NotificationsList from './NotificationsTab/NotificationsList';
import { filterOptions } from 'hooks/useNotification';

const Notifications: React.FC = () => {
  const [addOpen, toggleAddDrawer] = useToggle(false);
  const [selectedFilterOption, setSelectedFilterOption] = useState<
    'active' | 'historical' | 'sent'
  >('active');

  return (
    <div className="p-2">
      <Row className="mb-2 align-items-center justify-content-between">
        <Col>
          <div>Notifications</div>
        </Col>
        <Col xs="auto">
          <StylishNewButton onClick={toggleAddDrawer}>
            Add Notification
          </StylishNewButton>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col xs="auto">
          <StylishNewToggleButtonGroup
            className="justify-content-start"
            size="sml"
            data={filterOptions.map((opt) => ({
              label: opt.toUpperCase(),
              value: opt,
            }))}
            selected={selectedFilterOption}
            onChange={(value) =>
              setSelectedFilterOption(value as 'active' | 'historical' | 'sent')
            }
            onBlur={() => {}}
          />
        </Col>
      </Row>
      <NotificationsList filter={selectedFilterOption} />

      {addOpen ? <NewNotificationDrawer toggle={toggleAddDrawer} /> : null}
    </div>
  );
};

export default Notifications;
